<template>
    <Dialog v-model="show" @input="$listeners.input" :title="title" width="475" :show-close-button="showCloseButton" @close="fecharDialog">
        <v-form class="mt-10 justify-center" ref="form" @submit.prevent="confirm">
            <DateField class="justify-center mx-4" v-model="newDate" label="Nova data de vencimento desejada: " :rules="[$rules.required]" placeholder="Exemplo: 22/07/2025" required />

            <div class="d-flex justify-end" style="gap: 12px;">
                <v-btn class="transition" color="secondary" rounded @click="fecharDialog">
                    Fechar
                </v-btn>
                <v-btn class="transition" color="primary" rounded @click="confirm">
                    Confirmar
                </v-btn>
            </div>
        </v-form>
    </Dialog>
</template>

<script>
  import DateField from './DateField.vue'

  export default {
    name: 'DialogAlterarDataVencimentoBoleto',
    components: {
      DateField
    },
    props: {
      value: { type: Boolean, default: false },
      showCloseButton: { type: Boolean, default: true }
    },
    data: () => ({
      title: 'ALTERAR DATA DE VENCIMENTO DO BOLETO',
      newDate: null
    }),
    computed: {
      show: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    methods: {
      fecharDialog () {
        this.show = false
        this.$refs.form.reset()
        this.newDate = null
      },
      confirm () {
        const form = this.$refs.form
        if (form.validate()) {
          this.$emit('confirmarNovaData', this.newDate)
          this.fecharDialog()
        }
      }
    }
  }
</script>
